import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 48px 24px;
	text-align: center;
`

export const Title = styled.h2`
	margin: 0;
	font-size: 20px;
	font-weight: 600;
	color: #1f2937;
`

export const Message = styled.p`
	margin: 0;
	max-width: 420px;
	font-size: 14px;
	line-height: 1.5;
	color: #6b7280;
`

export const Actions = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 8px;
`

export const RetryButton = styled.button`
	padding: 10px 20px;
	border: none;
	border-radius: 8px;
	background: #2563eb;
	color: #fff;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;

	&:hover {
		background: #1d4ed8;
	}
`

export const SecondaryButton = styled.button`
	padding: 10px 20px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	background: #fff;
	color: #374151;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;

	&:hover {
		background: #f9fafb;
	}
`

/** Only rendered outside production, where the raw message is useful. */
export const Details = styled.pre`
	max-width: 100%;
	margin: 8px 0 0;
	padding: 12px;
	overflow-x: auto;
	border-radius: 8px;
	background: #f3f4f6;
	color: #b91c1c;
	font-size: 12px;
	text-align: left;
	white-space: pre-wrap;
	word-break: break-word;
`
